import { ContactType } from '../../../core-models';

export type ContactTypeName = (typeof ContactTypeName)[ContactType];

export const ContactTypeName = {
    [ContactType.Builder]: 'Builder',
    [ContactType.BuildingManager]: 'Building manager',
    [ContactType.BuildingSurveyor]: 'Building surveyor',
    [ContactType.Developer]: 'Developer',
    [ContactType.Insurer]: 'Insurer',
    [ContactType.SubContractor]: 'Sub-contractor',
    [ContactType.FacilitiesManager]: 'Facilities manager',
    [ContactType.ProjectManager]: 'Project manager',
} as const;

export function getContactTypeName(contactType: ContactType): ContactTypeName {
    return ContactTypeName[contactType];
}

export function getContactType(contactTypeName: ContactTypeName): ContactType {
    for (const key in ContactTypeName) {
        if (
            ContactTypeName[key as unknown as ContactType] === contactTypeName
        ) {
            return Number(key) as ContactType;
        }
    }
    throw new TypeError(`No ContactType found for name: ${contactTypeName}`);
}

export function isContactTypeName(
    contactTypeName: string
): contactTypeName is ContactTypeName {
    return (Object.values(ContactTypeName) as string[]).includes(
        contactTypeName
    );
}
